
$(document).ready(function(){
    $('.form-nl').submit(function(e){

        e.preventDefault();
        var url = '/nl-subscribe';

        var formData = {
            'email'         : $('#nlEmail').val(),
            '_token'        : $('input[name=_token]').val()
        };
        // Send the data using post
        var posting = $.ajax({
            url: url,
            type: "post",
            data: formData,
            dataType: 'json',
            success: function( data ) {
                $('.nlError').hide();
                $('.nlMerci').hide();
                if(data == '1') {
                    $('.nlMerci').removeClass('hidden').fadeIn();
                }else {
                    $('.nlError').removeClass('hidden').fadeIn();
                }
            },
            error: function( data ) {
                $('.nlError').hide();
                $('.nlMerci').hide();
                $('.nlError').removeClass('hidden').fadeIn();
            }
        });

        return false;
    });
});